export enum MessageTemplate {
    LoginLayout = 'Templates.LoginLayout',
}

export interface IMessageTemplate {
    id: number;
    name: string;
    value: string;
}
